export default "__VITE_ASSET__BtGcWXZA__"